// this is purely for ease of testing, since JSDOM makes it impossible to mock window.location
// remove if jest decides to ditch JSDOM in favour of something else https://jestjs.io/blog/2025/06/04/jest-30#known-issues

export function replaceLocation(newLocation: string) {
	window.location.replace(newLocation);
}

export function setCurrentPathname(newPathname: string) {
	window.location.pathname = newPathname;
}

export function reloadPage() {
	window.location.reload();
}
